import { doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Company } from '../models/Company';

// Your organization's company ID
const DEFAULT_COMPANY_ID = 'Oyxyl5p11Xh7MRrInrJp';

/**
 * Ensures the default company exists in Firestore
 */
export async function ensureDefaultCompanyExists(): Promise<Company> {
  const companyId = DEFAULT_COMPANY_ID;
  const companyRef = doc(db, 'companies', companyId);
  const companySnap = await getDoc(companyRef);

  if (!companySnap.exists()) {
    console.log('Creating default company...');
    const now = new Date();

    const company: Company = {
      id: companyId,
      name: 'VERA Health Technologies, LLC',
      email: 'thinkimaedu@gmail.com',
      createdAt: now,
      updatedAt: now,
      subscription: {
        plan: 'premium',
        storageLimit: 100, // 100 GB
        userLimit: 50,
      },
      settings: {
        folderStructure: 'user',
        namingConvention: '{name}_{date}_{vid}',
        retentionDays: 365,
      },
    };

    await setDoc(companyRef, {
      ...company,
      createdAt: Timestamp.fromDate(company.createdAt),
      updatedAt: Timestamp.fromDate(company.updatedAt),
    });

    console.log('Default company created successfully');
    return company;
  }

  const data = companySnap.data();
  return {
    id: companySnap.id,
    name: data.name,
    email: data.email,
    phone: data.phone,
    address: data.address,
    logoUrl: data.logoUrl,
    createdAt: data.createdAt?.toDate() || new Date(),
    updatedAt: data.updatedAt?.toDate() || new Date(),
    subscription: data.subscription,
    settings: data.settings,
  } as Company;
}
